import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { COLOR_PRIMARY_2, COLOR_PRIMARY_2_300, COLOR_PRIMARY_2_500, COLOR_PRIMARY_2_700 } from 'src/utils/colors';

const TooltipedActionButton = ({
  title,
  onClick,
  icon: IconComponent,
  label,
  smallLabel,
  highlight,
  animation,
}: {
  title: string;
  onClick: () => void;
  icon: any;
  label: string;
  smallLabel?: boolean;
  highlight?: boolean;
  animation?: string;
}) => {
  return (
    <Tooltip title={title}>
      <Button
        onClick={onClick}
        sx={
          highlight
            ? {
                background: COLOR_PRIMARY_2_700,
                color: '#fff',
                borderRadius: '8px',
                transform: 'scale(1.3)',
                transformOrigin: 'left',
                fontWeight: 'bold',
                '&:hover': {
                  background: COLOR_PRIMARY_2_300,
                },
                '& > *': {
                  transform: 'scale(0.8)',
                },
              }
            : {}
        }
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <IconComponent
            sx={{
              fontSize: 24,
              color: highlight ? '#fff' : COLOR_PRIMARY_2,
              animation: animation ? `${animation} 1s linear infinite` : '',
            }}
          />
          {smallLabel ? (
            <Typography sx={{ color: highlight ? 'white' : 'black', fontSize: '10px' }}>
              {label.split(' ').map((word, index) => (
                <span key={index}>
                  {word}{' '}
                  {/* {index < label.split(' ').length - 1 && <br />} */}
                </span>
              ))}
            </Typography>
          ) : (
            <Typography variant="caption" sx={{ color: 'black' }}>
              {label}
            </Typography>
          )}
        </Box>
      </Button>
    </Tooltip>
  );
};

export default TooltipedActionButton;
